import { createFileRoute } from '@tanstack/react-router';

import { OldReaderDemo } from 'src/components/material/reader-old/OldReaderDemo';
import pdfFixtureUrl from 'src/components/material/reader-poc/fixtures/LAD_Portal_Product_Update_Mar-Jul_2026.pdf?url';

const DOCUMENT_ID = 'fixture-pdf-product-update';

/**
 * The production PDF reader against the same fixture and local data used by
 * `/reader-poc/pdf`, making this an auth-free old/new comparison route.
 */
const OldReaderPage = () => (
  <OldReaderDemo documentId={DOCUMENT_ID} file={pdfFixtureUrl} />
);

export const Route = createFileRoute('/reader-old')({
  component: OldReaderPage,
});
